import { Reveal } from "@/components/site/Reveal";
import { SectionShell, SectionHead } from "@/components/site/Primitives";

const STAGES = [
  { n: "01", title: "Discover", copy: "Define the commercial event, decision workflow, users, data environment and measurable success criteria." },
  { n: "02", title: "Design", copy: "Configure approved inputs, commercial logic, decision experience and governance requirements." },
  { n: "03", title: "Build & Pilot", copy: "Connect selected data sources, deploy the initial workflow and run a controlled use case." },
  { n: "04", title: "Validate & Scale", copy: "Measure value, refine logic and controls, and prepare additional workflows or enterprise deployment." },
];

export function PilotJourney() {
  return (
    <SectionShell id="roadmap" tone="mist" prominent>
      <div className="max-w-3xl">
        <SectionHead
          label="Pilot Journey"
          labelColor="gold"
          title="Start with one high-value commercial decision."
          intro="A controlled, four-stage engagement that begins with a single decision and expands through validated commercial value."
        />
      </div>

      {/* Desktop / tablet grid */}
      <div className="relative mt-14 hidden gap-5 sm:grid sm:grid-cols-2 lg:grid-cols-4">
        {STAGES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.08}>
            <div className="relative flex h-full flex-col rounded-2xl border border-natsu-navy/12 bg-white p-6 sm:p-7">
              <span className="font-display text-3xl text-natsu-gold">{s.n}</span>
              <h3 className="mt-4 font-display text-xl text-natsu-navy">{s.title}</h3>
              <p className="mt-3 text-[14.5px] leading-relaxed text-natsu-slate">{s.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>

      {/* Mobile vertical timeline with continuous line */}
      <div className="mt-12 sm:hidden">
        <ol className="relative border-l-2 border-natsu-gold/30 pl-6">
          {STAGES.map((s) => (
            <li key={s.title} className="relative mb-8 last:mb-0">
              <span className="absolute -left-[35px] flex h-8 w-8 items-center justify-center rounded-full bg-natsu-gold font-display text-sm text-natsu-navy">
                {s.n}
              </span>
              <h3 className="font-display text-xl text-natsu-navy">{s.title}</h3>
              <p className="mt-2 text-[14px] leading-relaxed text-natsu-slate">{s.copy}</p>
            </li>
          ))}
        </ol>
      </div>
    </SectionShell>
  );
}
